// import React from "react";

// // reactstrap components
// import "components/custom.css";
// import API from "api.js";
// import PaymentFormIn from "components/Payments/PaymentFormIn";
// // import NotificationAlert from "react-notification-alert";
// import PaymentForm from "components/Payments/PaymentForm";
// import RightCard from "components/Payments/RightSideCard";
// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";
// import StripeElements from "components/Payments/StripeElements";
// import ErrorPopup from "components/PopUps/ErrorPopup";
// import SelectPaymentMethod from "components/Plans/SelectPaymentMethod";
// import errImage from "../assets/images/1-05.png";
// import ReactHtmlParser from "react-html-parser";
// import RazorPay from "components/Payments/Razorpay/RazorPay";
// import SidebarClose from "components/Sidebar/SidebarClose";

// let stripe;

// let publishableKey;
// if (import.meta.env.VITE_ENV === "production") {
//   publishableKey = import.meta.env.VITE_STRIPE_LIVE_APP_KEY
// } else {
//   publishableKey = import.meta.env.VITE_STRIPE_TEST_APP_KEY
// }
// const stripePromise = loadStripe(publishableKey);
// class Subscription extends React.Component {
//   state = {
//     cvc: "",
//     message: "",
//     expYear: "",
//     expMonth: "",
//     cardNumber: "",
//     formProcess: false,
//     paymentStatus: false,
//     plan: false,
//     country: null,
//     discount: false,
//     prorationSubtotal: null,
//     paymentError: {
//       hasError: false,
//       error: "",
//     },
//     paymentMethod: "CARD",
//   };

//   componentDidMount() {
//     this.loadPlan();
//     document
//       .getElementsByTagName("body")[0]
//       .classList.add("leftSidebarClosed", "package-payment-page");
//   }

//   componentWillUnmount() {
//     document
//       .getElementsByTagName("body")[0]
//       .classList.remove("leftSidebarClosed", "package-payment-page");
//   }

//   /**
//    * Load Selected Plan.
//    */
//   loadPlan = () => {
//     const base_url = import.meta.env.VITE_URL_ALT + "/api/v2/";
//     API({
//       method: "GET",
//       url: base_url + "plan/" + this.props.params?.id,
//     })
//       .then((data) => {
//         console.log("inside load plan");
        
//         const { data: plan, prorationSubtotal } = data.data;
//         const discount = prorationSubtotal !== null;
//         if (plan.new !== "YES") {
//           // this.props.history.replace("/admin/dashboard");
//           // return;
//         }
//         this.setState(
//           { plan, country: data.data.country, discount, prorationSubtotal },
//           () => {
//             this.loadStripe();
//           }
//         );
//       })
//       .catch(() => {});
//   };

//   handleChange = (evt) => {
//     this.setState({
//       [evt.target.name]: evt.target.value,
//     });
//   };

//   notify = (type, message) => {
//     switch (type) {
//       case 1:
//         type = "success";
//         break;
//       case 2:
//         type = "danger";
//         break;
//       default:
//         break;
//     }
//     var options = {};
//     options = {
//       place: "tr",
//       message: (
//         <div>
//           <div>{message}</div>
//         </div>
//       ),
//       type: type,
//       icon: "now-ui-icons ui-1_bell-53",
//       autoDismiss: 7,
//     };
//     // this.refs.notificationAlert.notificationAlert(options);
//   };

//   /**
//    * Api call to purchase.
//    */
//   purchase = async (data) => {
//     let bodyFormData = new FormData();
//     bodyFormData.set("plan", this.props.match.params.id);
//     bodyFormData.set("country", this.state.country);
//     // bodyFormData.set("token", data.stripe_token);
//     bodyFormData.set("token", data);

//     if (
//       this.state.discount &&
//       this.state.prorationSubtotal &&
//       this.state.prorationSubtotal.subtotal
//     ) {
//       bodyFormData.set("proration_time", this.state.prorationSubtotal.time);
//       bodyFormData.set(
//         "proration_subtotal",
//         this.state.prorationSubtotal.subtotal
//       );
//     }

//     // API call
//     let res = null;
//     const url = import.meta.env.VITE_URL_ALT + "/api/v2/subscribe";
//     try {
//       res = await API({
//         method: "POST",
//         url: url,
//         data: bodyFormData,
//       });
//     } catch (error) {
//       console.log(error);
//     }

//     // process if we get response from server.
//     if (res) {
//       // if success.
//       if (res.status === 200) {
//         if (res.data.actionRequired) {
//           const { paymentIntent, error } = await stripe.confirmCardPayment(
//             res.data.data.clientSecret
//           );

//           if (error) {
//             this.setState({
//               paymentError: { hasError: true, error: error.message },
//             });
//             // alert(error.message);
//             if (res.data.data.update_invoice) {
//               try {
//                 res = await API({
//                   method: "POST",
//                   url: "voidInvoice",
//                   data: { invoiceId: res.data.data.update_invoice },
//                 });
//               } catch (error) {
//                 console.log(error);
//               }
//             }
//           } else if (paymentIntent.status === "succeeded") {
//             this.notify(1, res.data.message);
//             this.setState({ paymentStatus: true });
//           }
//           // const res2 = await axios.get(`http://localhost:5000/check/${res.data.id}`);
//           // alert(`Payment successful, payment ID - ${res.data.id}`);
//         } else {
//           if (
//             res.data &&
//             res.data.data &&
//             res.data.data.status &&
//             res.data.data.status === "requires_payment_method"
//           ) {
//             this.notify(
//               1,
//               "Payment failed, please contact your card issuer, or use another payment method."
//             );
//             this.setState({
//               formProcess: false,
//             });
//             return;
//           }
//           this.notify(1, res.data.message);
//           this.setState({ paymentStatus: true });
//         }
//       }

//       // if failed.
//       if (!res.status) {
//         this.notify(1, "Something went wrong");
//       }

//       // set State message.
//       this.setState({
//         message: ``,
//         formProcess: false,
//       });
//     }
//   };

//   pay = async (e) => {
//     e.preventDefault();
//     if (
//       !this.state.cardNumber ||
//       !this.state.expMonth ||
//       !this.state.expYear ||
//       !this.state.cvv
//     ) {
//       this.setState({ message: "All fields are required" });
//       return;
//     }
//     this.setState({
//       formProcess: true,
//       message: "",
//     });

//     // Create token and send token to api.
//     window.stripeV2.createToken(
//       {
//         number: this.state.cardNumber,
//         exp_month: this.state.expMonth,
//         exp_year: this.state.expYear,
//         cvc: this.state.cvc,
//       },
//       async (status, response) => {
//         if (status === 200) {
//           this.purchase({ stripe_token: response.id });
//         } else {
//           this.setState({
//             message: response.error.message,
//             formProcess: false,
//           });
//         }
//       }
//     );

//     // window.Stripe.card.createToken(
//     //   {
//     //     number: this.state.cardNumber,
//     //     exp_month: this.state.expMonth,
//     //     exp_year: this.state.expYear,
//     //     cvc: this.state.cvc,
//     //   },
//     //   async (status, response) => {
//     //     if (status === 200) {
//     //       let bodyFormData = new FormData();
//     //       bodyFormData.set("plan", this.props.match.params.id);
//     //       bodyFormData.set("token", response.id);
//     //       bodyFormData.set("country", this.state.country);
//     //       let res = null;
//     //       try {
//     //         res = await API({
//     //           method: "POST",
//     //           url: "subscribe",
//     //           data: bodyFormData,
//     //         });
//     //       } catch (error) {
//     //         console.log(error);
//     //       }
//     //       if (res) {
//     //         if (res.status === 200) {
//     //           this.notify(1, res.data.message);
//     //           this.setState({ paymentStatus: true });
//     //         }
//     //         if(!res.status) {
//     //           this.notify(1, "Something went wrong");
//     //         }
//     //         this.setState({
//     //           message: ``,
//     //           formProcess: false,
//     //         });
//     //       }
//     //     } else {
//     //       this.setState({
//     //         message: response.error.message,
//     //         formProcess: false,
//     //       });
//     //     }
//     //   }
//     // );
//   };

//   loadStripe = () => {
//     const { country } = this.state;
//     let key;

//     if (import.meta.env.VITE_ENV === "production") {
//       key = import.meta.env.VITE_STRIPE_LIVE_APP_KEY
//     } else {
//       key = import.meta.env.VITE_STRIPE_TEST_APP_KEY
//     }

//     // if(process.env.NODE_ENV === 'production') {
//     //   key = process.env.REACT_APP_STRIPE_LIVE_APP_KEY;
//     // } else {
//     //   key = process.env.REACT_APP_STRIPE_TEST_APP_KEY;
//     // }
//     // console.log('key', key); // change keys in env

//     if (!window.document.getElementById("stripe-script")) {
//       // var s = window.document.createElement("script");
//       // s.id = "stripe-script";
//       // s.type = "text/javascript";
//       // s.src = "https://js.stripe.com/v2/";
//       // s.onload = () => {
//       //   window["Stripe"].setPublishableKey(key);
//       //   window["stripeV2"] = window.Stripe;

//       // };
//       // window.document.body.appendChild(s);
//       var s = window.document.createElement("script");
//       s.id = "stripe-script";
//       s.type = "text/javascript";
//       s.src = "https://js.stripe.com/v3/";
//       s.onload = () => {
//         stripe = window.Stripe(key);
//       };
//       window.document.body.appendChild(s);
//     }
//   };

//   /**
//    * initiate UPI payment.
//    */
//   upiSelected = () => {
//     this.props.history.push(`/admin/ccav/plans`);
//   };

//   /**
//    * render stripe payment form.
//    */
//   stripeForm = () => {
//     return (
//       <div className="panel panel-default">
//         {/*<h2 className="paymentFormTitle">Payments</h2>*/}
//         <Elements
//           children={
//             <StripeElements
//               stripe={stripePromise}
//               purchase={this.purchase}
//               message={this.state.message}
//               formProcess={this.state.formProcess}
//               planIsValid={this.state.plan.price === 0 ? false : true}
//               setFormProcess={(status) =>
//                 this.setState({ formProcess: status })
//               }
//             />
//           }
//           stripe={stripePromise}
//         />
//         <p className="mt-2"></p>
//       </div>
//     );
//   };

//   selectedMethod = (method) => {
//     this.setState({ paymentMethod: method });
//   };

//   render() {
//     if (this.state.paymentStatus) {
//       // localStorage.setItem('paySuccessStatus','true');
//       this.props.history.push(
//         `/admin/sub/success?p=${
//           this.state.plan.price
//         }&currency=${ReactHtmlParser(this.state.plan.currency)}`
//       );
//     }

//     return (
//       <>
//         <div className="content">
//           {/*<SidebarClose />*/}
//           <div className="">
//             {this.state.paymentError.hasError && (
//               <ErrorPopup
//                 country={this.state.country}
//                 upi={this.upiSelected}
//                 toggle={() => {
//                   this.setState({
//                     paymentError: { hasError: false, error: "" },
//                   });
//                 }}
//                 message="Payment failed"
//                 subMessage={this.state.paymentError.error}
//                 img={
//                   <img src={errImage} style={{ width: "50%" }} alt="Error" />
//                 }
//               />
//             )}
//             {/* <NotificationAlert ref="notificationAlert" /> */}
//             <div className="row paymentFormOuter">
//               <div className="col-xs-12 mr-auto pt-5 subPaymentPage paymentFormBlk">
//                 {this.state.country !== null &&
//                 this.state.country !== "IN" &&
//                 this.state.plan !== false ? (
//                   <div className="panel panel-default">
//                     <h2 className="paymentFormTitle">Payments</h2>
//                     <Elements
//                       children={
//                         <StripeElements
//                           stripe={stripePromise}
//                           purchase={this.purchase}
//                           message={this.state.message}
//                           formProcess={this.state.formProcess}
//                           planIsValid={
//                             this.state.plan.price === 0 ? false : true
//                           }
//                           setFormProcess={(status) =>
//                             this.setState({ formProcess: status })
//                           }
//                         />
//                       }
//                       stripe={stripePromise}
//                     />
//                     <p className="mt-2"></p>
//                   </div>
//                 ) : (
//                   <SelectPaymentMethod
//                     stripeForm={this.stripeForm}
//                     country={this.state.country}
//                     isGold={this.state.plan.is_gold}
//                     selectedMethod={this.selectedMethod}
//                     plan={this.state.plan}
//                   />
//                 )}
//               </div>

//               {/* {this.state.plan && (
//                 <RightCard
//                   plan={this.state.plan}
//                   discount={this.state.discount}
//                   prorationSubtotal={this.state.prorationSubtotal}
//                   paymentMethod={this.state.paymentMethod}
//                 />
//               )} */}
//             </div>
//           </div>
//         </div>
//       </>
//     );
//   }
// }

// export default Subscription;


import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";

// reactstrap components
import "components/custom.css";
import API from "api.js";
import { setAlert } from "action";
import PaymentFormIn from "components/Payments/PaymentFormIn";
// import NotificationAlert from "react-notification-alert";
import PaymentForm from "components/Payments/PaymentForm";
import RightCard from "components/Payments/RightSideCard";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripeElements from "components/Payments/StripeElements";
import ErrorPopup from "components/PopUps/ErrorPopup";
import SelectPaymentMethod from "components/Plans/SelectPaymentMethod";
import errImage from "../assets/images/1-05.png";
import ReactHtmlParser from "react-html-parser";
import RazorPay from "components/Payments/Razorpay/RazorPay";
import SidebarClose from "components/Sidebar/SidebarClose";
import { useDispatch } from "react-redux";

let stripe;

let publishableKey;
if (import.meta.env.VITE_ENV === "production") {
  publishableKey = import.meta.env.VITE_STRIPE_LIVE_APP_KEY;
} else {
  publishableKey = import.meta.env.VITE_STRIPE_TEST_APP_KEY;
}
const stripePromise = loadStripe(publishableKey);

const Subscription = () => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  
  const [state, setState] = useState({
    cvc: "",
    message: "",
    expYear: "",
    expMonth: "",
    cardNumber: "",
    formProcess: false,
    paymentStatus: false,
    plan: false,
    country: null,
    discount: false,
    prorationSubtotal: null,
    paymentError: {
      hasError: false,
      error: "",
    },
    paymentMethod: "CARD",
    loading: false,
    upiLoading: false,
  });

  useEffect(() => {
    loadPlan();
    document.getElementsByTagName("body")[0].classList.add("package-payment-page");

    return () => {
      document.getElementsByTagName("body")[0].classList.remove("package-payment-page");
    };
  }, []);

  /**
   * Load Selected Plan.
   */
  const loadPlan = () => {
    const base_url = import.meta.env.VITE_URL_ALT + "/api/v2/";
     setState((prevState) => ({
      ...prevState,
      loading: true,
    }));
    API({
      method: "GET",
      url: base_url + "plan/" + params?.id,
    })
      .then((data) => {
        console.log("inside load plan");
        
        const { data: plan, prorationSubtotal } = data.data;
        const discount = prorationSubtotal !== null;
        if (plan.new !== "YES") {
          // history.replace("/admin/dashboard");
          // return;
        }
        setState((prevState) => ({
          ...prevState,
          plan,
          country: data.data.country,
          discount,
          prorationSubtotal,
        }));
        loadStripe();
      })
      .catch(() => {
        dispatch(
        setAlert({ flag: true, type: 2, message: "Something went wrong." })
        );
         setState((prevState) => ({
        ...prevState,
         loading: false,
        }));
      });
  };

  const handleChange = (evt) => {
    setState((prevState) => ({
      ...prevState,
      [evt.target.name]: evt.target.value,
    }));
  };

  const notify = (type, message) => {
    switch (type) {
      case 1:
        type = "success";
        break;
      case 2:
        type = "danger";
        break;
      default:
        break;
    }
    var options = {};
    options = {
      place: "tr",
      message: (
        <div>
          <div>{message}</div>
        </div>
      ),
      type: type,
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 7,
    };
    // notificationAlertRef.current.notificationAlert(options);
  };

  /**
   * Api call to purchase.
   */
  const purchase = async (data) => {
    let bodyFormData = new FormData();
    bodyFormData.set("plan", params.id);
    bodyFormData.set("country", state.country);
    // bodyFormData.set("token", data.stripe_token);
    bodyFormData.set("token", data);

    if (
      state.discount &&
      state.prorationSubtotal &&
      state.prorationSubtotal.subtotal
    ) {
      bodyFormData.set("proration_time", state.prorationSubtotal.time);
      bodyFormData.set(
        "proration_subtotal",
        state.prorationSubtotal.subtotal
      );
    }

    // API call
    let res = null;
    const url = import.meta.env.VITE_URL_ALT + "/api/v2/subscribe";
    try {
      res = await API({
        method: "POST",
        url: url,
        data: bodyFormData,
      });
    } catch (error) {
      console.log(error);
    }

    // process if we get response from server.
    if (res) {
      // if success.
      if (res.status === 200) {
        if (res.data.actionRequired) {
          const { paymentIntent, error } = await stripe.confirmCardPayment(
            res.data.data.clientSecret
          );

          if (error) {
            setState((prevState) => ({
              ...prevState,
              paymentError: { hasError: true, error: error.message },
            }));
            // alert(error.message);
            if (res.data.data.update_invoice) {
              try {
                res = await API({
                  method: "POST",
                  url: "voidInvoice",
                  data: { invoiceId: res.data.data.update_invoice },
                });
              } catch (error) {
                console.log(error);
              }
            }
          } else if (paymentIntent.status === "succeeded") {
            notify(1, res.data.message);
            setState((prevState) => ({
              ...prevState,
              paymentStatus: true,
            }));
          }
          // const res2 = await axios.get(`http://localhost:5000/check/${res.data.id}`);
          // alert(`Payment successful, payment ID - ${res.data.id}`);
        } else {
          if (
            res.data &&
            res.data.data &&
            res.data.data.status &&
            res.data.data.status === "requires_payment_method"
          ) {
            notify(
              1,
              "Payment failed, please contact your card issuer, or use another payment method."
            );
            setState((prevState) => ({
              ...prevState,
              formProcess: false,
            }));
            return;
          }
          notify(1, res.data.message);
          setState((prevState) => ({
            ...prevState,
            paymentStatus: true,
          }));
        }
      }

      // if failed.
      if (!res.status) {
        notify(1, "Something went wrong");
      }

      // set State message.
      setState((prevState) => ({
        ...prevState,
        message: ``,
        formProcess: false,
      }));
    }
  };

  const pay = async (e) => {
    e.preventDefault();
    if (
      !state.cardNumber ||
      !state.expMonth ||
      !state.expYear ||
      !state.cvv
    ) {
      setState((prevState) => ({
        ...prevState,
        message: "All fields are required",
      }));
      return;
    }
    setState((prevState) => ({
      ...prevState,
      formProcess: true,
      message: "",
    }));

    // Create token and send token to api.
    window.stripeV2.createToken(
      {
        number: state.cardNumber,
        exp_month: state.expMonth,
        exp_year: state.expYear,
        cvc: state.cvc,
      },
      async (status, response) => {
        if (status === 200) {
          purchase({ stripe_token: response.id });
        } else {
          setState((prevState) => ({
            ...prevState,
            message: response.error.message,
            formProcess: false,
          }));
        }
      }
    );

    // window.Stripe.card.createToken(
    //   {
    //     number: state.cardNumber,
    //     exp_month: state.expMonth,
    //     exp_year: state.expYear,
    //     cvc: state.cvc,
    //   },
    //   async (status, response) => {
    //     if (status === 200) {
    //       let bodyFormData = new FormData();
    //       bodyFormData.set("plan", params.id);
    //       bodyFormData.set("token", response.id);
    //       bodyFormData.set("country", state.country);
    //       let res = null;
    //       try {
    //         res = await API({
    //           method: "POST",
    //           url: "subscribe",
    //           data: bodyFormData,
    //         });
    //       } catch (error) {
    //         console.log(error);
    //       }
    //       if (res) {
    //         if (res.status === 200) {
    //           notify(1, res.data.message);
    //           setState((prevState) => ({
    //             ...prevState,
    //             paymentStatus: true,
    //           }));
    //         }
    //         if(!res.status) {
    //           notify(1, "Something went wrong");
    //         }
    //         setState((prevState) => ({
    //           ...prevState,
    //           message: ``,
    //           formProcess: false,
    //         }));
    //       }
    //     } else {
    //       setState((prevState) => ({
    //         ...prevState,
    //         message: response.error.message,
    //         formProcess: false,
    //       }));
    //     }
    //   }
    // );
  };

  const loadStripe = () => {
    const { country } = state;
    let key;

    if (import.meta.env.VITE_ENV === "production") {
      key = import.meta.env.VITE_STRIPE_LIVE_APP_KEY;
    } else {
      key = import.meta.env.VITE_STRIPE_TEST_APP_KEY;
    }

    // if(process.env.NODE_ENV === 'production') {
    //   key = process.env.REACT_APP_STRIPE_LIVE_APP_KEY;
    // } else {
    //   key = process.env.REACT_APP_STRIPE_TEST_APP_KEY;
    // }
    // console.log('key', key); // change keys in env

    if (!window.document.getElementById("stripe-script")) {
      // var s = window.document.createElement("script");
      // s.id = "stripe-script";
      // s.type = "text/javascript";
      // s.src = "https://js.stripe.com/v2/";
      // s.onload = () => {
      //   window["Stripe"].setPublishableKey(key);
      //   window["stripeV2"] = window.Stripe;

      // };
      // window.document.body.appendChild(s);
      var s = window.document.createElement("script");
      s.id = "stripe-script";
      s.type = "text/javascript";
      s.src = "https://js.stripe.com/v3/";
      s.onload = () => {
        stripe = window.Stripe(key);
      };
      window.document.body.appendChild(s);
    }
  };

  /**
   * initiate UPI payment.
   */
  const upiSelected = () => {
    navigate(`/admin/ccav/plans`);
  };

  /**
   * render stripe payment form.
   */
  const stripeForm = () => {
    return (
      <div className="panel panel-default">
        {/*<h2 className="paymentFormTitle">Payments</h2>*/}
        <Elements
          children={
            <StripeElements
              stripe={stripePromise}
              purchase={purchase}
              message={state.message}
              formProcess={state.formProcess}
              planIsValid={state.plan.price === 0 ? false : true}
              setFormProcess={(status) =>
                setState((prevState) => ({
                  ...prevState,
                  formProcess: status,
                }))
              }
            />
          }
          stripe={stripePromise}
        />
        <p className="mt-2"></p>
      </div>
    );
  };

  const selectedMethod = (method) => {
    setState((prevState) => ({
      ...prevState,
      paymentMethod: method,
    }));
  };

    const handleUpiLoadingChange = (isLoading) => {
    setState((prevState) => ({
      ...prevState,
      upiLoading: isLoading,
      loading: isLoading ? prevState.loading : false,
    }));
  };

  if (state.paymentStatus) {
    // localStorage.setItem('paySuccessStatus','true');
    navigate(
      `/admin/sub/success?p=${
        state.plan.price
      }&currency=${ReactHtmlParser(state.plan.currency)}`
    );
  }
  

  return (
    <>
      <div className="content">
        {/*<SidebarClose />*/}
        <div className="">
          {state.paymentError.hasError && (
            <ErrorPopup
              country={state.country}
              upi={upiSelected}
              toggle={() => {
                setState((prevState) => ({
                  ...prevState,
                  paymentError: { hasError: false, error: "" },
                }));
              }}
              message="Payment failed"
              subMessage={state.paymentError.error}
              img={
                <img src={errImage} style={{ width: "50%" }} alt="Error" />
              }
            />
          )}
          {/* <NotificationAlert ref="notificationAlert" /> */}
          <div className="row paymentFormOuter">
            <div className="col-xs-12 mr-auto pt-5 subPaymentPage paymentFormBlk">
              {/* {state.country !== null &&
              state.country !== "IN" &&
              state.plan !== false ? (
                <div className="panel panel-default">
                  <h2 className="paymentFormTitle">Payments</h2>
                  <Elements
                    children={
                      <StripeElements
                        stripe={stripePromise}
                        purchase={purchase}
                        message={state.message}
                        formProcess={state.formProcess}
                        planIsValid={
                          state.plan.price === 0 ? false : true
                        }
                        setFormProcess={(status) =>
                          setState((prevState) => ({
                            ...prevState,
                            formProcess: status,
                          }))
                        }
                      />
                    }
                    stripe={stripePromise}
                  />
                  <p className="mt-2"></p>
                </div>
              ) : ( */}
                <SelectPaymentMethod
                  stripeForm={stripeForm}
                  country={state.country}
                  isGold={state.plan.is_gold}
                  selectedMethod={selectedMethod}
                  plan={state.plan}
                  loading={state.loading || state.upiLoading}
                  onUpiLoadingChange={handleUpiLoadingChange}
                />
              {/* )} */}
            </div>

            {/* {state.plan && (
              <RightCard
                plan={state.plan}
                discount={state.discount}
                prorationSubtotal={state.prorationSubtotal}
                paymentMethod={state.paymentMethod}
              />
            )} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Subscription;